// import React, { useState } from 'react';
// import {Link} from 'react-router-dom'
import { ResponsiveBar } from '@nivo/bar'



const MyResponsiveBar = ({ monthlyJobs }) => (
    <ResponsiveBar
        data={
            monthlyJobs
        //     [
        //     {
        //       "country": "AD",
        //       "hot dog": 20,
        //       "hot dogColor": "",
        //       "burger": 67,
        //       "burgerColor": "hsl(253, 70%, 50%)",
        //       "sandwich": 99,
        //       "sandwichColor": "hsl(208, 70%, 50%)",
        //       "kebab": 54,
        //       "kebabColor": "hsl(38, 70%, 50%)",
        //       "fries": 173,
        //       "friesColor": "hsl(136, 70%, 50%)",
        //       "donut": 92,
        //       "donutColor": "hsl(14, 70%, 50%)"
        //     },
        //     {
        //       "country": "AE",
        //       "hot dog": 50,
        //       "hot dogColor": "hsl(69, 70%, 50%)",
        //       "burger": 124,
        //       "burgerColor": "hsl(32, 70%, 50%)",
        //       "sandwich": 185,
        //       "sandwichColor": "hsl(191, 70%, 50%)",
        //       "kebab": 17,
        //       "kebabColor": "hsl(215, 70%, 50%)",
        //       "fries": 171,
        //       "friesColor": "hsl(107, 70%, 50%)",
        //       "donut": 52,
        //       "donutColor": "hsl(173, 70%, 50%)"
        //     },
        //   
          }
        keys={
            // [ 'hot dog', 'burger', 'sandwich', 'kebab', 'fries', 'donut' ]
            ['DOORLAND','DOORSEA','PORTAIR','DOORCOURIER']}
        indexBy="MONTH"
        margin={{ top: 50, right: 50, bottom: 80, left: 70 }}
        padding={0.3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={{ scheme: 'category10' }}
        // fill={[
        //     {
        //         match: {
        //             id: 'DOORCOURIER'
        //         },
        //         id: 'dots'
        //     },
        //     {
        //         match: {
        //             id: 'DOORLAND'
        //         },
        //         id: 'lines'
        //     }
        // ]}
        borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
        axisTop={null}
        axisRight={null}
        // axisBottom={{
        //     tickSize: 5,
        //     tickPadding: 10,
        //     tickRotation: 0,
        //     legend: 'Months',
        //     legendPosition: 'middle',
        //     legendOffset: 32
        // }}
        axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Jobs',
            legendPosition: 'middle',
            legendOffset: -40
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
        legends={[
            {
                anchor: 'bottom',
                direction: 'row',
                justify: false,
                translateX: 0,
                translateY: 56,
                itemsSpacing: 0,
                itemWidth: 100,
                itemHeight: 18,
                itemTextColor: '#999',
                itemDirection: 'left-to-right',
                itemOpacity: 1,
                symbolSize: 18,
                symbolShape: 'circle',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemTextColor: '#000'
                        }
                    }
                ]
            }
        ]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
    />
)

export default MyResponsiveBar;


